import React from 'react';
import { Building2 } from 'lucide-react';
import { useTheme } from '../../ThemeContext';


export default function AvatarUploadSection({
  avatarUrl,
  avatarPreview,
  avatarFile,
  avatarError,
  organizationName,
  onFileSelect,
  onRemove,
  isSubmitting
}) {
  const { t, isDark } = useTheme();
  return (
    <div style={{
      display: 'flex',
      gap: '32px',
      marginBottom: '32px',
      paddingBottom: '32px',
      borderBottom: '1px solid #e7e5e4'
    }}>
      {/* Avatar Preview */}
      <div style={{ flexShrink: 0 }}>
        {avatarUrl || avatarPreview ? (
          <img
            src={avatarPreview || avatarUrl}
            alt={organizationName}
            style={{
              width: '120px',
              height: '120px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: `2px solid ${t.borderStrong}`
            }}
          />
        ) : (
          <div style={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            backgroundColor: t.buttonBg,
            color: t.buttonText,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '48px',
            fontWeight: '600',
            fontFamily: 'Poppins, sans-serif',
            border: `2px solid ${t.borderStrong}`
          }}>
            <Building2 size={48} />
          </div>
        )}
      </div>

      {/* Upload Controls */}
      <div style={{ flex: 1 }}>
        <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          marginBottom: '8px',
          fontFamily: 'Poppins, sans-serif',
          color: t.text
        }}>
          Organization Logo
        </h3>
        <p style={{
          fontSize: '13px',
          color: t.textSecondary,
          marginBottom: '16px',
          fontFamily: 'Poppins, sans-serif',
          lineHeight: '1.5'
        }}>
          Upload a square image (PNG or JPG). Max 2MB. Image will be automatically cropped to fit.
        </p>

        <input
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          onChange={onFileSelect}
          style={{ display: 'none' }}
          id="avatar-upload"
        />
        
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <label
            htmlFor="avatar-upload"
            style={{
              display: 'inline-block',
              padding: '10px 20px',
              borderRadius: '6px',
              border: `1px solid ${t.borderStrong}`,
              backgroundColor: 'transparent',
              color: t.text,
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              fontFamily: 'Poppins, sans-serif',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = t.accent;
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = t.borderStrong;
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            {avatarFile ? 'Change Image' : 'Upload Image'}
          </label>

          {(avatarFile || avatarUrl) && (
            <button
              onClick={onRemove}
              disabled={isSubmitting}
              style={{
                padding: '10px 20px',
                borderRadius: '6px',
                border: `1px solid ${t.error}`,
                backgroundColor: 'transparent',
                color: t.error,
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                fontFamily: 'Poppins, sans-serif',
                transition: 'all 0.2s',
                opacity: isSubmitting ? 0.5 : 1
              }}
              onMouseEnter={(e) => {
                if (!isSubmitting) {
                  e.currentTarget.style.backgroundColor = t.error;
                  e.currentTarget.style.color = t.surface;
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = t.error;
              }}
            >
              Remove
            </button>
          )}
        </div>

        {avatarError && (
          <p style={{
            fontSize: '12px',
            color: t.error,
            marginTop: '8px',
            fontFamily: 'Poppins, sans-serif'
          }}>
            {avatarError}
          </p>
        )}
        {avatarFile && !avatarError && (
          <p style={{
            fontSize: '12px',
            color: t.success,
            marginTop: '8px',
            fontFamily: 'Poppins, sans-serif'
          }}>
            ✓ Ready to upload: {avatarFile.name}
          </p>
        )}
      </div>
    </div>
  );
}
